module.exports = __webpack_public_path__ + "static/media/img23.8181b6f7.jpg";